"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _react = _interopRequireDefault(require("react"));

var _reactRedux = require("react-redux");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _H = _interopRequireDefault(require("UIComponents/elements/headings/H1"));

var _H2 = _interopRequireDefault(require("UIComponents/elements/headings/H5"));

var _colors = require("HubStyleTokens/colors");

var _UIIcon = _interopRequireDefault(require("UIComponents/icon/UIIcon"));

var _Breakpoints = require("pricing-pages-unified-ui/constants/Breakpoints");

var _GuaranteeBlob = _interopRequireDefault(require("./GuaranteeBlob"));

var _SignupButton = _interopRequireDefault(require("pricing-pages-unified-ui/components/public-only/SignupButton"));

var _EnvironmentWrapper = _interopRequireDefault(require("pricing-pages-unified-ui/components/EnvironmentWrapper"));

var _responsiveBreakpoints = _interopRequireDefault(require("../../utils/responsiveBreakpoints"));

var _LoadingStateSelectors = require("../../selectors/LoadingStateSelectors");

var _SkeletonLoadWrapper = _interopRequireDefault(require("../loading/SkeletonLoadWrapper"));

function _templateObject4() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n    height: auto;\n  "]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  display: flex;\n  text-align: center;\n  flex-direction: column;\n  align-items: center;\n  margin-top: 80px;\n  margin-bottom: 30px;\n  padding: 40px 16px;\n  width: 100%;\n  height: 400px;\n  position: relative;\n  z-index: 1;\n\n  @media (max-width: ", "px) {\n    background-color: ", ";\n    margin-top: 40px;\n    margin-bottom: 0;\n    padding-bottom: 2.1em;\n  }\n  ", ";\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  display: flex;\n  justify-content: space-between;\n  flex-wrap: nowrap;\n  margin-bottom: 24px;\n  width: 100%;\n  max-width: 870px;\n\n  @media (max-width: ", "px) {\n    flex-direction: column;\n    align-items: center;\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  width: 240px;\n  text-align: center;\n  @media (max-width: ", "px) {\n    &:not(:last-child) {\n      margin-bottom: 10px;\n    }\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var Guarantee = (0, _styledComponents.default)(function (_ref) {
  var className = _ref.className,
      icon = _ref.icon,
      header = _ref.header,
      body = _ref.body;
  return _react.default.createElement("div", {
    className: className
  }, _react.default.createElement("div", null, _react.default.createElement(_UIIcon.default, {
    name: icon,
    color: _colors.FLINT,
    size: "medium",
    className: "m-bottom-2"
  })), _react.default.createElement("div", null, _react.default.createElement(_H2.default, null, header)), _react.default.createElement("div", null, body));
}).withConfig({
  displayName: "GuaranteeSection__Guarantee",
  componentId: "gcinwp-0"
})(_templateObject(), _Breakpoints.GUARANTEE_SECTION);

var GuaranteeRow = _styledComponents.default.div.withConfig({
  displayName: "GuaranteeSection__GuaranteeRow",
  componentId: "gcinwp-1"
})(_templateObject2(), _Breakpoints.GUARANTEE_SECTION);

var GuaranteeSection = (0, _styledComponents.default)(function (_ref2) {
  var className = _ref2.className;
  var hasPricingAndPurchasingSucceeded = (0, _reactRedux.useSelector)(_LoadingStateSelectors.hasPricingAndPurchasingSucceededSelector);
  return _react.default.createElement("div", {
    className: className
  }, _react.default.createElement(_GuaranteeBlob.default, null), _react.default.createElement(_H.default, {
    className: "m-bottom-12 text-center"
  }, _react.default.createElement(_FormattedMessage.default, {
    message: "pricingPage.pages.crm.guarantee"
  })), _react.default.createElement(GuaranteeRow, null, _react.default.createElement(Guarantee, {
    icon: "lists",
    header: _react.default.createElement(_FormattedMessage.default, {
      message: "pricingPage.pages.crm.unlimitedHeader"
    }),
    body: _react.default.createElement(_FormattedMessage.default, {
      message: "pricingPage.pages.crm.unlimitedBody"
    })
  }), _react.default.createElement(Guarantee, {
    icon: "tag",
    header: _react.default.createElement(_FormattedMessage.default, {
      message: "pricingPage.pages.crm.freeHeader"
    }),
    body: _react.default.createElement(_FormattedMessage.default, {
      message: "pricingPage.pages.crm.freeBody"
    })
  }), _react.default.createElement(Guarantee, {
    icon: "generateChart",
    header: _react.default.createElement(_FormattedMessage.default, {
      message: "pricingPage.pages.crm.dataHeader"
    }),
    body: _react.default.createElement(_FormattedMessage.default, {
      message: "pricingPage.pages.crm.dataBody"
    })
  })), _react.default.createElement(_EnvironmentWrapper.default, {
    publicNode: _react.default.createElement(_SkeletonLoadWrapper.default, {
      isLoading: !hasPricingAndPurchasingSucceeded,
      widths: [200],
      heights: [56]
    }, _react.default.createElement(_SignupButton.default, {
      sourceId: "crm-pricing-middle"
    }))
  }));
}).withConfig({
  displayName: "GuaranteeSection",
  componentId: "gcinwp-2"
})(_templateObject3(), _Breakpoints.GUARANTEE_SECTION, _colors.GYPSUM, _responsiveBreakpoints.default.tablet(_templateObject4()));
var _default = GuaranteeSection;
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./js/components/free-tools-page/GuaranteeSection.js
// module id = 592
// module chunks = 5 6